<div class="card card-nav-tabs mt-0 rounded-lg border-0 shadow-lg container p-4">

      <div class="">
          <button class="btn btn-primary-dark btn-sm rounded text-xxs shadow mb-1 mt-3"
              data-bs-toggle="modal"
              data-bs-target="#create_quote"
              @click="open_create_modal">
          Create Quote
          </button>

      </div>
      <div class="table-responsive mt-2">
        <table id="forms_table" class="table table-hover">
          <thead class="custom-header">
            <tr>
              <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Quote Number</th>
              <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Status</th>
              <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Date Issued</th>
              <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Valid Until</th>
              <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Date Created</th>
              <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="form in forms" :key="form.id">
              <td class="text-xxs text-start">{{ form.quote_number }}</td>
              <td class="text-xxs text-start">{{ form.quote_status.code }}</td>
              <td class="text-xxs text-start">{{ form.date_issued }}</td>
              <td class="text-xxs text-start">{{ form.valid_until }}</td>
              <td class="text-xxs text-start">{{ form.date_created }}</td>
              <td>
                  <button class="btn btn-primary-dark btn-sm rounded shadow me-2 text-xxs"
                          data-bs-toggle="modal"
                          data-bs-target="#edit_quote"
                          @click="open_edit_modal(form)">Edit</button>

                  <button class="btn btn-primary-dark btn-sm rounded shadow me-2 text-xxs"
                          data-bs-toggle="modal"
                          data-bs-target="#assign_services"
                          @click="open_assign_modal(form)">Assign</button>

            <button class="btn btn-primary-dark btn-sm rounded shadow me-2 text-xxs" data-bs-toggle="modal"
              data-bs-target="#preview_quote" @click="open_preview_quote(form)">
              Preview Quote
            </button>



          </td>
        </tr>
      </tbody>
    </table>
  </div>

</div>

<teleport to="body">
  <div class="modal fade" id="edit_quote" tabindex="-1" aria-labelledby="edit_quote_label" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
        <div class="modal-header border-bottom-0 cute-header shadow-lg">
          <h5 class="modal-title text-white text-xxs">Edit Quote</h5>
          <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            <label class="modal-form-label form-label text-xxs">Quote Number:</label>
            <input type="text" class="modal-form-control form-control text-xxs" v-model="current_form.quote_number"
              placeholder="Enter quote number">
          </div>
          <div class="mb-3">
            <label class="modal-form-label form-label text-xxs">Date Issued:</label>
            <input type="date" class="modal-form-control form-control text-xxs" v-model="current_form.date_issued"
              placeholder="Select date issued">
          </div>
          <div class="mb-3">
            <label class="modal-form-label form-label text-xxs">Valid Until:</label>
            <input type="date" class="modal-form-control form-control text-xxs" v-model="current_form.valid_until"
              placeholder="Select valid until date">
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
            @click="update_quotes">
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
</teleport>

<teleport to="body">
  <div class="modal fade" id="create_quote" tabindex="-1" aria-labelledby="create_quote_label" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
              <div class="modal-header border-bottom-0 cute-header shadow-lg">
                  <h5 class="modal-title text-white text-xxs">Create Quote</h5>
                  <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body">
                  <div class="mb-3">
                      <label class="modal-form-label form-label text-xxs">Date Issued:</label>
                      <input type="date" class="modal-form-control form-control text-xxs" v-model="current_form.date_issued" placeholder="Select date issued">
                  </div>
                  <div class="mb-3">
                      <label class="modal-form-label form-label text-xxs">Valid Until:</label>
                      <input type="date" class="modal-form-control form-control text-xxs" v-model="current_form.valid_until" placeholder="Select valid until date">
                  </div>
              </div>
              <div class="modal-footer">
                  <button type="button" class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark" @click="create_quotes">Save</button>
              </div>
          </div>
      </div>
  </div>
</teleport>

<teleport to="body">
  <div class="modal fade" id="assign_services" tabindex="-1" aria-labelledby="assign_services_label" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered ">
      <div class="modal-content bg-white rounded-3 p-0 shadow-lg">

        <!-- MODAL HEADER -->
        <div class="modal-header border-bottom-0 cute-header shadow-lg">
          <h5 class="modal-title text-white text-xxs">Assign Service Packages</h5>
          <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <!-- MODAL BODY -->
        <div class="modal-body">
          <div v-for="(package_service, package_serviceIndex) in table_safe_packages" :key="package_service.id" class="card mb-3 border-0 shadow-sm">

            <!-- COLLAPSIBLE PACKAGE HEADER -->
            <div class="card-header bg-light d-flex justify-content-between align-items-center"
                data-bs-toggle="collapse"
                :data-bs-target="'#collapse-package_service-' + package_service.id"
                aria-expanded="true"
                :aria-controls="'collapse-package_service-' + package_service.id"
                >
              <div class="form-check">
                <input class="form-check-input" type="checkbox" :id="'package-' + package_service.id" v-model="package_service.selected" @click.stop>
                <label class="form-check-label fw-bold text-xxs" :for="'package-' + package_service.id">
                  {{ package_service.name }}
                </label>
              </div>
              <div class="d-flex align-items-center gap-3">
                <span class="text-muted text-xxs">Base Price: R{{ package_service.base_price }}</span>
                <i class="fa fa-chevron-down text-muted"></i>
              </div>
            </div>

            <!-- COLLAPSIBLE PACKAGE SERVICES TABLE -->
            <div :id="'collapse-package_service-' + package_service.id" class="collapse show">
              <div class="card-body py-2">
                <div class="table-responsive rounded-lg border table-border-color p-3 shadow-sm">
                  <table class="table table-hover">
                    <thead class="custom-header">
                      <tr>
                        <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Service</th>
                        <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Description</th>
                        <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Price</th>
                        <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Quantity</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="service in package_service.services" :key="service.id">
                        <td class="text-xxs text-start ps-3">{{ service.name }}</td>
                        <td class="text-xxs text-start ps-3">{{ service.description }}</td>
                        <td class="text-xxs text-start ps-3">R{{ service.price }}</td>
                        <td class="ps-3">
                          <input type="number" class="form-control form-control-sm text-xxs" v-model.number="service.quantity" min="1" />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

          </div>
        </div>

        <!-- MODAL FOOTER -->
        <div class="modal-footer">
          <button type="button" class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark" @click="save_assignment">Save Assignment</button>
        </div>

      </div>
    </div>
  </div>
</teleport>

<teleport to="body">
  <div class="modal fade" id="preview_quote" tabindex="-1" aria-labelledby="previewQuoteLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
        <div class="modal-header border-bottom-0 cute-header shadow-lg">
          <h5 class="modal-title text-white text-xxs" id="previewQuoteLabel">Quote Preview</h5>
          <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="modal-body p-0">
          <div class="ratio ratio-4x3">
            <iframe
              v-if="preview_url"
              :src="preview_url"
              allowfullscreen
            ></iframe>
            <div v-else class="d-flex align-items-center justify-content-center w-100 h-100">
              No preview available.
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-primary-dark" @click="send_quote_email">
              Send via Email
          </button>
        </div>
      </div>
    </div>
  </div>
</teleport>






